// Purchase order status definitions with colors
export const purchaseOrderStatuses = [
  { value: 'Draft', color: 'default' },
  { value: 'Pending', color: 'blue' },
  { value: 'Approved', color: 'green' },
  { value: 'Ordered', color: 'cyan' },
  { value: 'Received', color: 'purple' },
  { value: 'Cancelled', color: 'red' },
  { value: 'Rejected', color: 'volcano' }
]

// Purchase order approval roles
export const approvalRoles = {
  DEPARTMENT_HEAD: 'Department Head',
  FINANCIAL_CONTROLLER: 'Financial Controller',
  PROCUREMENT_MANAGER: 'Procurement Manager'
}

// Approval threshold amounts
export const approvalThresholds = {
  DEPARTMENT_LIMIT: 5000, // Department head can approve up to this amount
  FINANCIAL_LIMIT: 25000, // Financial controller can approve up to this amount
  PROCUREMENT_REVIEW: 10000 // Orders above this amount require procurement review
}

// Purchase order types
export const orderTypes = {
  STANDARD: 'Standard',
  EMERGENCY: 'Emergency',
  PLANNED: 'Planned',
  CONTRACT: 'Contract'
}

// Payment terms
export const paymentTerms = [
  { value: 'net30', label: 'Net 30' },
  { value: 'net60', label: 'Net 60' },
  { value: 'net90', label: 'Net 90' },
  { value: 'cod', label: 'Cash on Delivery' },
  { value: 'prepaid', label: 'Prepaid' }
]
